import { version as VERSION } from '../package.json';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const ENV: string;

export const version = VERSION;
export * from './core/routing';
export { define as defineRouterView } from './components/router-view/router-view';
export { define as defineRouterLink } from './components/router-link/router-link';
export { define as defineRouterLinkTarget } from './components/router-link/router-link-target';
export { define as defineRouterViewQuery } from './components/router-view/router-view-query';
